import { onError } from "@apollo/client/link/error";
const getTraceIdFromHeaders = (headers) => {
    try {
        if (!headers)
            return undefined;
        // Extract symbols from the headers
        const headerListsymbol = Object.getOwnPropertySymbols(headers).find((symbol) => symbol.toString() === "Symbol(headers list)");
        if (!headerListsymbol)
            return undefined;
        const headerMapSymbol = Object.getOwnPropertySymbols(headers[headerListsymbol]).find((symbol) => symbol.toString() === "Symbol(headers map)");
        if (!headerMapSymbol)
            return undefined;
        //extract the Trace-id
        return headers[headerListsymbol][headerMapSymbol].get("trace-id").value;
    }
    catch (error) {
        console.log("Error extracting trace-id from headers", error);
    }
};
//link to log details of query and fetch trace id from response header when error occurs
export const logginglink = () => onError(({ graphQLErrors, networkError, operation }) => {
    try {
        //get the name of the query
        const queryName = operation.operationName;
        //get the response header
        const context = operation.getContext();
        let traceId;
        if (context.response) {
            traceId = getTraceIdFromHeaders(context.response.headers);
        }
        //Log traceid and query name when the error occurs
        if ((graphQLErrors || networkError) && traceId) {
            console.log("Error in operation:", queryName, ", Trace ID:", traceId);
        }
    }
    catch (error) {
        console.log("Error logging details of query and related trace-id:", error);
    }
});
//# sourceMappingURL=logging.js.map